<template>
  <div class="tableSection">
    <!-- <b-row v-if="loaded"> -->
    <div class="titleTable">VARIÁVEIS DE RESPOSTA</div>
    <b-row>
      <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
        <table class="table table-hover table-sm">
          <thead class="thead-dark">
          </thead>
          <template v-if="json.length == 0">Sem dados para visualização<br></template>
          <tbody v-else>
            <tr v-for="item in json" :key="item.id">
              <td v-if="item.root == 'true'" class="text-truncate tableTxt area" colspan="15"
                style="max-width: 250px; text-overflow: ellipsis">
                {{ item.item }}
              </td>
              <template v-else>
                <td class="text-truncate tableTxt" :title="item.item" style="max-width: 230px; text-overflow: ellipsis">
                  {{ item.item }}
                </td>
                <td class="text-truncate tableTxt" style="max-width: 250px; text-overflow: ellipsis">
                  {{ item.value | numberFormat }}
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { urlMainAPI, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "GridOutputPlan",

  inject: ["showLoading"],

  components: {},

  computed: mapState(["msg"]),

  watch: {
    valorSelect() {
      this.loadtable();
    },

    revisionSelect() {
      this.loadtable();
    },

    updateTableEvent(data) {
      this.json = data;
      defaultSuccess(this.$t('variaveis-de-resposta-atualizadas'))
    }
  },
  props: ["valorSelect", "yearSelect","revisionSelect", 'updateTableEvent', "table"],
  data: function () {
    return {
      json: [],
    };
  },
  filters: {
    numberFormat(num) {
      try {
        if (!num) {
          return num
        }
        if (num.toString().includes(",")) {
          num = num.toString().replace(',', '.')
        }
        if (!isNaN(parseFloat(num))) {
          var numParsed = parseFloat(num);
          if (numParsed > 0 && numParsed < 1 || numParsed < 0 && numParsed > -1) {
            numParsed = numParsed.toFixed(5);
          } else {
            numParsed = numParsed.toFixed(3);
          }
          numParsed = numParsed.replace('.', ',').split(",")
          let v1 = numParsed[0]
          let v2 = numParsed[1]
          v1 = v1.split("").reverse()
          let i = 0
          var stop = 0
          if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3);
          }
          if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3) - 1
          }
          var pos = 3
          if (i >= 1) {
            for (i; i <= stop; i++) {
              v1.splice(pos, 0, ".");
              pos = pos + 4;
            }
          }
          numParsed = v1.reverse().join("") + ',' + v2
          if (numParsed.includes("-.")) {
            numParsed = numParsed.replace("-.", "-");
          }
          return numParsed
        }
        return num
      } catch (error) {
        return num
      }
    },
  },
  methods: {
    async loadtable() {
      if (this.yearSelect != null) {
        const url = `${urlMainAPI}/getproductionplanoutput/${this.yearSelect}/${this.revisionSelect.id}/${this.valorSelect}`;
        await axios
          .get(url)
          .then((res) => {
            this.json = res.data.table;
            this.$emit("table", this.json);
          })
          .catch();
      }
    },
  },
  created() { },
  mounted() { }
};
</script>

<style scoped>
.titleTable {
  text-align: center;
  margin: 10px auto 5px auto;
  border-bottom: 2px solid black;
}

table {
  border-collapse: initial;
  border-spacing: initial;
  font-size: 12px;
}

.my-custom-scrollbar {
  max-height: 22.5vh;
  overflow: auto;
  margin: 0px auto;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;

}

.rowDistance {
  margin-top: 20px;
}

.tableSection {
  margin: 0px
}

.area {
  background-color: rgb(59, 58, 58);
  color: white;
  text-align: center;
}

img {
  max-height: 45px;
}

@media (max-width: 1200px) {}
</style>
